import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createStatCardBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/layoutBlockHelpers/statCardBlockHelper";
import { getBorderRadiusOptions } from "../../../utils/imgStyleHelpers";
import { getSizingOptions } from "../../../utils/sizeStyleHelpers";
import { getTextAlignOptions } from "../../../utils/textStyleHelpers";
import { createImageBlock } from "../../utils/mediaBlockHelpers";
import {
  createButtonBlock,
  createH1Block,
  createH2Block,
  createPBlock,
} from "../../utils/textBlocksHelpers";
import { getAboutUsBlockPrimaryStyleOptions } from "../constants";
import imagePlaceholder from "./about_us_block_1_placeholder.png";

const stats = [
  {
    number: "94%",
    text: "Client satisfaction rate",
  },
  {
    number: "150+",
    text: "Executive coaches",
  },
  {
    number: "12+",
    text: "Years of experience",
  },
  {
    number: "30+",
    text: "Industries served",
  },
] as const;

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "AboutUsBlock1",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH1Block({
          text: "Our Journey to Helping You Grow with Community",
        }),
      ],
    },
    content: {
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: "At Clarity Coaching, we believe true growth happens within a strong, supportive community. Our coaching goes beyond one-on-one sessions—we offer mastermind groups, real-time support, and expert guidance to help leaders gain confidence, overcome challenges, and make bold decisions. By fostering meaningful connections, we ensure you have the tools, insights, and encouragement needed to lead with clarity and success.",
        }),
      ],
    },
    actions: {
      prop: "children",
      type: "children",
      value: [
        createButtonBlock({
          text: "Book a Session",
          href: "#",
        }),
      ],
    },
    image: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: imagePlaceholder,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                maxHeight: "36.5rem",
                maxWidth: "none",
                width: "100%",
                height: "100%",
                minHeight: "auto",
                minWidth: "auto",
              },
            }),
            borderRadius: getBorderRadiusOptions({
              defaultValue: {
                border_left_top_radius: 20,
                border_left_bottom_radius: 20,
                border_right_top_radius: 20,
                border_right_bottom_radius: 20,
              },
            }),
          },
        }),
      ],
    },
    footer: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Clarity Coaching Elevate Your Leadership Journey",
          styles: {
            textAlign: getTextAlignOptions("center"),
          },
        }),
        createPBlock({
          text: "Clarity Coaching empowers leaders with expert guidance, mastermind sessions, and real-time support. Build confidence, make bold decisions, and grow within a strong community designed to elevate your leadership journey.",
          styles: {
            textAlign: getTextAlignOptions("center"),
          },
        }),
      ],
    },
    cards: {
      prop: "children",
      type: "children",
      value: stats.map(stat => createStatCardBlock(stat)),
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getAboutUsBlockPrimaryStyleOptions(),
      },
    },
  },
};
